<div [ngClass]="{ 'm-active': isSidebarActive }" class="sidebar-wrapper">
  <app-icon (click)="isSidebarActive = false; toggleSideBar.emit(false)" [cssStyle]="{ cursor: 'pointer' }" color="var(--text-color-light)" iconName="list" size="24px"></app-icon>
  <div class="mt-46 d-flex justify-content-start align-items-center">
    <div class="image-wrapper">
      <img [appFetchProfileImage]="userDetail?.memberId" alt="" src="assets/images/placeholder.png" />
    </div>
    <div class="ml-16">
      <h2 class="user-name">{{ userDetail.firstName }} {{ userDetail.lastName || '' }}</h2>
      <p class="user-role">
        {{ userDetail.club.name }}
      </p>
      <p class="user-role">
        {{ userDetail.roles[0] }}
      </p>
    </div>
  </div>
  <div class="line mt-18"></div>
  <div class="navbar-menu-items mt-25" dir="auto">
    @for (item of sidebarItems; track item; let i = $index) {
      @if (shellService.allowedAccess(item)) {
        <div [class.active]="item.active" class="menu">
          <a (click)="activateSidebarItem(i)" class="menu-item">
            <div class="item">
              @if (item.active) {
                <app-icon [color]="'var(--dull-gray)'" [cssStyle]="{ marginTop: '-2px' }" [iconName]="item.icon" size="24px"></app-icon>
              }
              @if (!item.active) {
                <app-icon [cssStyle]="{ marginTop: '-2px' }" [iconName]="item.icon" color="var(--dull-gray)" size="24px"></app-icon>
              }
              <span>{{ item.title | translate }}</span>
            </div>
            <div class="submenu-icon" id="submenu-icon">
              @if (item.subItems && item.subItems.length && sidebarExtendedItem === i) {
                <app-icon [color]="'var(--text-color-light)'" iconName="chevron-down" size="16px"></app-icon>
              }
              @if (item.subItems && item.subItems.length && sidebarExtendedItem !== i) {
                <app-icon color="var(--text-color-light)" iconName="chevron-right" size="16px"></app-icon>
              }
            </div>
          </a>
          @if (item.subItems) {
            <ul [style.display]="sidebarExtendedItem === i ? 'block' : 'none'" class="sub-menu-items">
              @for (subItem of item.subItems; track subItem) {
                @if (shellService.allowedAccess(subItem)) {
                  <li [class.disabled]="subItem.disabled">
                    @if (subItem.href && !subItem.url) {
                      <a (click)="onSubMenuClick(i, subItem)" [class.active]="subItem.active" [routerLink]="subItem.href">
                        <app-icon [color]="'var(--dull-gray)'" [iconName]="subItem.icon" size="24px"></app-icon>
                        <span>{{ subItem.title | translate }}</span>
                      </a>
                    }
                    @if (subItem.url && !subItem.href) {
                      <a (click)="onSubMenuClick(i, subItem)" [class.active]="subItem.active" [href]="subItem.url" target="_blank">
                        <app-icon [color]="'var(--dull-gray)'" [iconName]="subItem.icon" size="24px"></app-icon>
                        <span>{{ subItem.title | translate }}</span>
                      </a>
                    }
                  </li>
                }
              }
            </ul>
          }
        </div>
      }
    }
  </div>
</div>
